<p-toast></p-toast>

<h2 class="page-title">
  {{ "i18n.domain.order.overview.title" | translate }}
</h2>

<div class="data-table">
  <p-toolbar>
    <ng-template pTemplate="right">
      <app-search-field
        (searchTextChanged)="onSearchTextChanged($event)"
      ></app-search-field>
      <p-button
        label="Export"
        icon="pi pi-download"
        [outlined]="true"
        (onClick)="exportMenu.toggle($event)"
      ></p-button>
      <p-menu #exportMenu [model]="exportMenuItems" [popup]="true"></p-menu>
    </ng-template>
  </p-toolbar>

  <p-table
    #dt
    [value]="data"
    dataKey="id"
    [paginator]="true"
    [rows]="pagedQuery.take"
    [totalRecords]="totalNoOfRecords"
    [lazy]="true"
    (onLazyLoad)="onFilter($event)"
    [rowsPerPageOptions]="[15, 30, 50, 100]"
    (onFilter)="onFilter($event)"
    (onSort)="onSort($event)"
    responsiveLayout="scroll"
    [globalFilterFields]="globalFilters"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Orders"
    [showCurrentPageReport]="true"
    styleClass="dt-grid dt-expandable"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="col-expand"></th>
        <th pSortableColumn="orderNumber" class="col-order-num">
          {{ "i18n.domain.order.fields.orderNumber" | translate }}
          <p-sortIcon field="orderNumber"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="orderNumber"
            display="menu"
            matchMode="contains"
            [showMatchModes]="true"
            [showOperator]="false"
            [showAddButton]="false"
          ></p-columnFilter>
        </th>

        <th pSortableColumn="buyer.firstname" class="col-name">
          {{ "i18n.domain.order.fields.buyerName" | translate }}
          <p-sortIcon field="buyer.firstname"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="buyerName"
            display="menu"
            matchMode="contains"
            [showMatchModes]="true"
            [showOperator]="false"
            [showAddButton]="false"
          >
          </p-columnFilter>
        </th>

        <th
          *ngIf="authService.isUserAdmin()"
          pSortableColumn="seller.firstname"
          class="col-name"
        >
          {{ "i18n.domain.order.fields.SellerName" | translate }}
          <p-sortIcon field="seller.firstname"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="sellerName"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          >
          </p-columnFilter>
        </th>

        <th pSortableColumn="orderDate" class="col-date">
          {{ "i18n.domain.order.fields.orderDate" | translate }}
          <p-sortIcon field="orderDate"></p-sortIcon>
          <p-columnFilter
            type="date"
            field="orderDate"
            display="menu"
            matchMode="dateIs"
            [showMatchModes]="true"
            [showOperator]="false"
            [showAddButton]="false"
          >
          </p-columnFilter>
        </th>

        <th pSortableColumn="totalAmount" class="dt-num col-amount">
          {{ "i18n.domain.order.fields.amount" | translate }} (₹)
          <p-sortIcon field="totalAmount"></p-sortIcon>
          <p-columnFilter
            type="numeric"
            field="totalAmount"
            display="menu"
            matchMode="equals"
            [showMatchModes]="true"
            [showOperator]="false"
            [showAddButton]="false"
          >
          </p-columnFilter>
        </th>

        <th pSortableColumn="status" class="col-status">
          {{ "i18n.domain.order.fields.status" | translate }}
          <p-sortIcon field="status"></p-sortIcon>
          <p-columnFilter
            field="status"
            matchMode="equals"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-dropdown
                [ngModel]="value"
                [options]="statusFilterOptions"
                (onChange)="filter($event.value)"
                placeholder="Select Status"
                [showClear]="true"
                optionLabel="label"
                optionValue="value"
              >
                <ng-template let-option pTemplate="item">
                  <span>{{ option.label }}</span>
                </ng-template>
              </p-dropdown>
            </ng-template>
          </p-columnFilter>
        </th>

        <th
          pSortableColumn="contactNumber"
          [class]="
            authService.isUserAdmin()
              ? 'col-mobile col-mobile--last'
              : 'col-mobile'
          "
        >
          {{ "i18n.domain.order.fields.contact" | translate }}
          <p-sortIcon field="contactNumber"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="contactNumber"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          >
          </p-columnFilter>
        </th>

        <th *ngIf="!authService.isUserAdmin()" class="col-action"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr>
        <td class="col-expand">
          <button
            pButton
            pRipple
            type="button"
            [icon]="
              expandedRowId === order.orderId
                ? 'pi pi-chevron-down'
                : 'pi pi-chevron-right'
            "
            (click)="toggleRow(order.orderId)"
            class="p-button-text p-button-rounded p-button-sm expand-btn"
          ></button>
        </td>
        <td class="col-order-num">{{ order.orderNumber }}</td>

        <td class="col-name">{{ order.buyerName }}</td>
        <td *ngIf="authService.isUserAdmin()" class="col-name">
          {{ order.sellerName }}
        </td>
        <td class="col-date">
          {{ order.orderDate | date: "dd-MM-yyyy HH:mm" }}
        </td>
        <td class="dt-num col-amount">
          {{ order.totalAmount | number: "1.2-2" }}
        </td>
        <td class="col-status">{{ getStatusName(order.status) }}</td>
        <td
          [class]="
            authService.isUserAdmin()
              ? 'col-mobile col-mobile--last'
              : 'col-mobile'
          "
        >
          {{ order.contactNumber }}
        </td>

        <td *ngIf="!authService.isUserAdmin()" class="col-action">
          <div class="grid-commands">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [outlined]="true"
              severity="success"
              (click)="openEdit(order)"
            >
            </p-button>
          </div>
        </td>
      </tr>

      <tr *ngIf="expandedRowId === order.orderId" class="expanded-row">
        <td
          [attr.colspan]="authService.isUserAdmin() ? 8 : 8"
          class="expanded-cell"
        >
          <div class="expanded-content">
            <div class="delivery-grid">
              <div class="delivery-item">
                <strong>{{
                  "i18n.domain.order.fields.deliveryaddress" | translate
                }}</strong>
                {{ order.deliveryAddress || "-" }}
              </div>
              <div class="delivery-item">
                <ng-container
                  *ngIf="
                    order.deliveryInstructions &&
                    order.deliveryInstructions.trim() !== ''
                  "
                >
                  <strong>{{
                    "i18n.domain.order.fields.instructions" | translate
                  }}</strong>
                  {{ order.deliveryInstructions }}
                </ng-container>
                <ng-container
                  *ngIf="
                    order.cancellationReason &&
                    order.cancellationReason.trim() !== ''
                  "
                >
                  <strong>{{
                    "i18n.domain.order.fields.cancellationReason" | translate
                  }}</strong>
                  {{ order.cancellationReason }}
                </ng-container>
                <ng-container
                  *ngIf="
                    (!order.deliveryInstructions ||
                      order.deliveryInstructions.trim() === '') &&
                    (!order.cancellationReason ||
                      order.cancellationReason.trim() === '')
                  "
                >
                  &nbsp;
                </ng-container>
              </div>
            </div>

            <table class="products-table">
              <thead>
                <tr>
                  <th>
                    {{ "i18n.domain.order.fields.productname" | translate }}
                  </th>
                  <th class="dt-num">
                    {{ "i18n.domain.order.fields.quantity" | translate }}
                  </th>
                  <th class="dt-num">
                    {{ "i18n.domain.order.fields.unitprice" | translate }} (₹)
                  </th>
                  <th class="dt-num">
                    {{ "i18n.domain.order.fields.totalprice" | translate }} (₹)
                  </th>
                  <th>{{ "i18n.domain.order.fields.status" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of order.items">
                  <td>{{ item.productName }}</td>
                  <td class="dt-num">{{ item.quantity }}</td>
                  <td class="dt-num">{{ item.unitPrice | number: "1.2-2" }}</td>
                  <td class="dt-num">
                    {{ item.totalPrice | number: "1.2-2" }}
                  </td>
                  <td>{{ getProductStatusName(item.status) }}</td>
                </tr>
                <tr *ngIf="!order.items || order.items.length === 0">
                  <td colspan="5" class="empty-message">No products found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">
          {{ "i18n.domain.order.messages.noOrdersFound" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- ───────────────────────── Edit Dialog ───────────────────────── -->
  <p-dialog
    [(visible)]="orderDialog"
    [style]="{ width: '500px' }"
    [modal]="true"
    styleClass="p-fluid order-dialog"
  >
    <!-- Header — same pattern as client-administration dialog -->
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <span class="dialog-title">
          {{ "i18n.domain.order.overview.edit-dialog-title" | translate }}
        </span>
      </div>
    </ng-template>

    <!-- Content -->
    <ng-template pTemplate="content">
      <form [formGroup]="orderForm" class="p-fluid" *ngIf="orderForm">
        <!-- ── Cancelled (read-only) ── -->
        <ng-container *ngIf="selectedOrder?.status === OrderStatus.Cancelled">
          <div class="field">
            <label for="cancellationReason">{{
              "i18n.domain.order.fields.cancellationReason" | translate
            }}</label>
            <textarea
              id="cancellationReason"
              pInputTextarea
              formControlName="CancelationReason"
              rows="3"
              placeholder="No cancellation reason provided"
            ></textarea>
          </div>
        </ng-container>

        <!-- ── Delivered (read-only) ── -->
        <ng-container *ngIf="selectedOrder?.status === OrderStatus.Delivered">
          <div class="field">
            <label for="status">{{
              "i18n.domain.order.fields.status" | translate
            }}</label>
            <p-dropdown
              id="status"
              [options]="filteredStatusOptions"
              optionLabel="label"
              optionValue="value"
              formControlName="status"
              placeholder="Select status"
              [disabled]="true"
            ></p-dropdown>
          </div>
          <div class="field">
            <label for="deliveryInstructions">{{
              "i18n.domain.order.fields.instructions" | translate
            }}</label>
            <textarea
              id="deliveryInstructions"
              pInputTextarea
              formControlName="deliveryInstructions"
              rows="3"
              placeholder="No delivery instructions"
              [disabled]="true"
            ></textarea>
          </div>
        </ng-container>

        <!-- ── Active order (editable) ── -->
        <ng-container
          *ngIf="
            selectedOrder?.status !== OrderStatus.Cancelled &&
            selectedOrder?.status !== OrderStatus.Delivered
          "
        >
          <!-- Normal edit view -->
          <ng-container *ngIf="!showCancellationReason">
            <div class="field">
              <label for="status">{{
                "i18n.domain.order.fields.status" | translate
              }}</label>
              <p-dropdown
                id="status"
                [options]="filteredStatusOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="status"
                placeholder="Select status"
              ></p-dropdown>
            </div>
            <div class="field">
              <label for="deliveryInstructions">{{
                "i18n.domain.order.fields.instructions" | translate
              }}</label>
              <textarea
                id="deliveryInstructions"
                pInputTextarea
                formControlName="deliveryInstructions"
                rows="3"
                placeholder="Enter delivery instructions"
              ></textarea>
            </div>
          </ng-container>

          <!-- Cancellation reason view -->
          <div class="field" *ngIf="showCancellationReason">
            <label for="cancellationReason">
              {{ "i18n.domain.order.fields.cancellationReason" | translate }}
              <span class="text-red-500">*</span>
            </label>
            <textarea
              id="cancellationReason"
              pInputTextarea
              formControlName="CancelationReason"
              rows="3"
              placeholder="Enter cancellation reason"
            ></textarea>
            <small
              class="p-error"
              *ngIf="
                orderForm.get('CancelationReason')?.invalid &&
                orderForm.get('CancelationReason')?.touched
              "
            >
              Cancellation reason is required
            </small>
          </div>
        </ng-container>
      </form>
    </ng-template>

    <!-- Footer — same styled pattern as client-administration dialog -->
    <ng-template pTemplate="footer">
      <!-- Read-only states: Cancelled or Delivered → single Close button -->
      <div
        class="flex justify-content-end w-full"
        *ngIf="
          selectedOrder?.status === OrderStatus.Cancelled ||
          selectedOrder?.status === OrderStatus.Delivered
        "
      >
        <p-button
          label="{{ 'i18n.shared.close' | translate }}"
          icon="pi pi-times"
          [text]="true"
          (onClick)="hideOrderDialog()"
        ></p-button>
      </div>

      <!-- Active order footer: delete/cancel on left, cancel+save on right -->
      <div
        class="flex justify-content-between align-items-center w-full"
        *ngIf="
          selectedOrder?.status !== OrderStatus.Cancelled &&
          selectedOrder?.status !== OrderStatus.Delivered
        "
      >
        <!-- Left side: delete / confirm-cancel -->
        <div>
          <p-button
            *ngIf="!showCancellationReason"
            label="{{ 'i18n.domain.order.fields.delete' | translate }}"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            (onClick)="onDeleteClick()"
          ></p-button>
          <p-button
            *ngIf="showCancellationReason"
            label="{{ 'i18n.domain.order.message.confirm-cancel' | translate }}"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            (onClick)="cancelOrder()"
            [disabled]="!orderForm?.valid"
          ></p-button>
        </div>

        <!-- Right side: cancel + save -->
        <div class="flex gap-2">
          <p-button
            label="{{ 'i18n.shared.cancel' | translate }}"
            icon="pi pi-times"
            [text]="true"
            (onClick)="hideOrderDialog()"
          ></p-button>
          <p-button
            *ngIf="!showCancellationReason"
            label="{{ 'i18n.shared.save' | translate }}"
            icon="pi pi-check"
            [text]="true"
            (onClick)="saveOrder()"
            [disabled]="!orderForm?.valid"
          ></p-button>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>
